'use es6';

import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateQueryParamTerm } from 'pricing-pages-unified-ui/actions/QueryParamTermActions';
import { queryParamTermSelector } from 'pricing-pages-unified-ui/selectors/QueryParamTermSelectors';
import { validatedQueryParamTermForSkuSelector, validateQueryParamTermForCrmSuiteSelector } from 'pricing-pages-unified-ui/selectors/OfferSelectors';
export function useMergeState(initialState = {}) {
  const [state, setState] = useState(initialState);

  const mergeState = nextState => setState(oldState => Object.assign({}, oldState, {}, nextState));

  return [state, mergeState];
}
export const useQueryParamTerm = () => {
  const dispatch = useDispatch();
  const queryParamTerm = useSelector(queryParamTermSelector);

  const setQueryParamTerm = updatedQueryParamTerm => {
    if (!updatedQueryParamTerm) return;
    dispatch(updateQueryParamTerm(updatedQueryParamTerm));
  };

  return {
    queryParamTerm,
    setQueryParamTerm
  };
};
export const useValidatedQueryParamTerm = skuId => {
  const queryParamState = useQueryParamTerm();
  const {
    setQueryParamTerm
  } = queryParamState;
  const queryParamTerm = useSelector(reduxState => validatedQueryParamTermForSkuSelector(reduxState, {
    skuId,
    queryParamTerm: queryParamState.queryParamTerm
  }));
  return {
    queryParamTerm,
    setQueryParamTerm
  };
};
export const useValidatedCrmSuiteQueryParamTerm = ({
  productLevel
}) => {
  const queryParamState = useQueryParamTerm();
  const {
    setQueryParamTerm
  } = queryParamState;
  const queryParamTerm = useSelector(reduxState => validateQueryParamTermForCrmSuiteSelector(reduxState, {
    queryParamTerm: queryParamState.queryParamTerm,
    productLevel
  }));
  return {
    queryParamTerm,
    setQueryParamTerm
  };
};